import {
  TrendingAd,
  TrendingAdsAllAdsOption,
  TrendingAdsSortOption,
} from "~src/types/ad";
import { ApiTypes, api } from "../common";
import { mergeAndCleanParams } from "../common/params";

const BRAND_PATHS: ApiTypes.API = {
  trendingAd: {
    path: `api/ads/facebook-ads/`,
    method: ApiTypes.HTTPMethod.GET,
  },
};

type TrendingAdsResponse = {
  count: number;
  full_count: number;
  next: string;
  previous: string;
  results: TrendingAd[];
};

export interface TrendingAdsParams extends TrendingAdsFilters {
  page?: number;
  page_size?: number;
  search_text?: string;
  randomize?: boolean;
}

export interface TrendingAdsFilters {
  all_ads?: TrendingAdsAllAdsOption;
  ordering?: TrendingAdsSortOption;
  ad_country?: string;
  ad_status?: string;
  brand_ids?: string;
  date_range?: string;
  media_type?: string;
  platform?: string;
  cta?: string[];
  duration?: string[];
  page_likes?: string;
}

const defaultParams: TrendingAdsParams = {
  page: 1,
  page_size: 10,
};

export const getTrendingAds = async (
  params: TrendingAdsParams,
  options?: { signal?: AbortSignal }
) => {
  const endpoint = BRAND_PATHS.trendingAd;
  const queryString = mergeAndCleanParams<TrendingAdsParams>(
    params,
    defaultParams,
  );
  const response = await api<TrendingAdsResponse>({
    method: endpoint.method,
    url: `${endpoint.path}?${queryString}`,
    signal: options?.signal
  });
  return response.data;
};